import { LogEntry } from './log';

export abstract class LogWriter {
  abstract write(logEntry: LogEntry): void;
}
